// Shared CRM-only profile snapshot mapping, preserving Customer360's existing identity joins.
export function serviceKey(row){
  if(row?.service_key)return row.service_key;
  const value=[row?.service_name,row?.platform_name,row?.platform_code,row?.brand_code,row?.product_code,row?.name].filter(Boolean).join(' ').toLowerCase();
  if(/website[ _-]*builder/.test(value))return 'website-builder';
  if(/profile/.test(value))return 'profiles';
  if(/e[- ]?learning|elearning|highfield/.test(value))return 'elearning';
  if(/e[- ]?sign|esign/.test(value))return 'esign';
  if(/reward/.test(value))return 'rewards';
  if(/knowhow|know[ _-]?how/.test(value))return 'knowhow';
  if(/pathway/.test(value))return 'pathway';
  if(/courier/.test(value))return 'courier';
  if(/\bsites?\b|managed website/.test(value))return 'sites';
  return '';
}

// Profile snapshots are keyed by the permanent Profile ID, never by mutable usernames.
export function customerProfiles(record){
  // Customer360 returns individual platform-account rows AND platform snapshots.
  // Profiles publishes the profile array under platformMetadata.profiles on its
  // customer snapshot, not necessarily on the linked account row.
  const byId=new Map();
  const sources=[...(record?.services||[]),...(record?.platformAccounts||[])].filter(row=>serviceKey(row)==='profiles');
  const parse=value=>{
    if(!value)return null;
    if(typeof value==='object')return value;
    if(typeof value==='string'){try{return JSON.parse(value);}catch{return null;}}
    return null;
  };
  const collect=(value,depth=0)=>{
    if(depth>4)return;
    const data=parse(value);
    if(!data)return;
    if(Array.isArray(data)){for(const item of data)collect(item,depth+1);return;}
    if(typeof data!=='object')return;
    if(Array.isArray(data.profiles)){
      for(const profile of data.profiles){
        const numeric=Number(profile?.id);
        if(!Number.isSafeInteger(numeric)||numeric<1)continue;
        const profileId=`SMP-${String(numeric).padStart(8,'0')}`;
        byId.set(profileId,{...profile,profileId});
      }
    }
    for(const key of ['platformMetadata','platform_metadata','metadata','metadata_json','snapshot','snapshot_json','snapshot_data','snapshot_payload','snapshot_data_json','data','data_json','payload','payload_json']){
      if(data[key]&&data[key]!==data)collect(data[key],depth+1);
    }
  };
  for(const row of sources)collect(row);
  return [...byId.values()];
}

